export const objPriceLayout = {
  amount: 899000,
  house: 'House',
  sqft: 478,
  bed: 2,
  bath: 3,
  car: 2,
  sqftText: 'Sq.Ft',
  address: '13633 Terrace Pl, Whittier, CA 90601',
  bidCount: 1,
};
